export default {fields:{locationSchemas:{spreads:{LocationSchema:{}}}},typenameResolver:'QueryTypenameResolver'}